module.exports = __webpack_public_path__ + "img/download_googleplayTW.01d9ef6d.png";